<template>
  <div id="new-negotiation">
    <BreadCrumb :items="breadcrumbItems" />
    <v-card elevation="2" class="py-5 mt-1">
      <div class="header pr-5 pb-5">
        <h1>Nova Negociação por peso</h1>
        <div class="mt10"></div>
        <p class="pl-9">Insira as informações da negociação por peso</p>
      </div>

      <v-form @submit.prevent="submit">
        <v-row class="px-9">
          <v-col cols="12" md="3">
            <v-text-field v-model="upToWeight" label="Peso"></v-text-field>
          </v-col>

          <v-col cols="12"></v-col>

          <v-col cols="12" md="3">
            <v-text-field v-model="price" label="Valor"></v-text-field>
          </v-col>

          <MessagesError :errors="errors" @closeMessages="errors = []" />

          <v-col cols="12" class="d-flex justify-end">
            <v-btn large color="info" class="mr-5" @click="cancel()">
              VOLTAR
            </v-btn>
            <v-btn
              large
              color="success"
              @click="submit()"
              :loading="loadingToCreate"
            >
              SALVAR
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import BreadCrumb from "../../../components/BreadCrumb.vue";
import MessagesError from "../../../components/MessagesError.vue";

export default {
  name: "NewNegotiation",
  components: {
    BreadCrumb,
    MessagesError,
  },
  data: () => ({
    price: null,
    upToWeight: null,
    errors: [],
    negotiationCityId: null,
    negotiationCpfOrCnpjId: null,
    loadingCity: false,
    success: false,
    loading: false,
    loadingToCreate: false,
  }),
  computed: {
    id() {
      return this.$route.params.id;
    },
    type() {
      return this.$route.params.type;
    },
    breadcrumbItems() {
      return [
        {
          text: "Início",
          disabled: false,
          to: "#",
        },
        {
          text: "Transbordos",
          disabled: false,
          to: "/transhipments/",
          exact: true,
        },
        {
          text: "Negociações",
          disabled: false,
          to: "/transhipments/negotiations",
          exact: true,
        },

        {
          text: "Nova negociação por peso",
          disabled: true,
        },
      ];
    },
    isEdit() {
      return this.$route.name === "EditNegotiationWeight";
    },
    isCity() {
      return this.$route.params.type === "1";
    },
  },
  mounted() {
    if (this.isEdit) {
      this.fetchMyNegotiationWeightByID();
    }
  },
  methods: {
    ...mapActions("AdressStore", ["fetchStates", "fetchCities"]),
    ...mapActions("TranshipmentStore", [
      "createNegotiationWeight",
      "fetchNegotiationWeigthByID",
      "editNegotiationWeigthByID",
    ]),
    async fetchMyNegotiationWeightByID() {
      try {
        const data = await this.fetchNegotiationWeigthByID({
          id: this.id,
          type: this.type,
        });

        this.price = data.price;
        this.upToWeight = data.upToWeight;
        this.negotiationCityId = data.negotiationCityId;
        this.negotiationCpfOrCnpjId = data.negotiationCpfOrCnpjId;
      } catch (e) {
        console.error(e);
      }
    },
    async submit() {
      this.loadingToCreate = true;
      console.log(this.isCity);
      console.log(this.isEdit);

      const theID = this.isEdit
        ? this.isCity
          ? this.negotiationCityId
          : this.negotiationCpfOrCnpjId
        : this.id;

      let params = {
        [this.isCity ? "negotiationCityId" : "negotiationCpfOrCnpjId"]: theID,
        upToWeight: Number(String(this.upToWeight).split(",").join(".")),
        price: Number(String(this.price).split(",").join(".")),
      };

      if (this.isEdit) {
        params.id = this.id;
      }

      try {
        const status = this.isEdit
          ? await this.editNegotiationWeigthByID(params)
          : await this.createNegotiationWeight(params);
        if (status.success) {
          this.$router.back();
        } else {
          this.errors = status.errors;
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.loadingToCreate = false;
      }
    },
    cancel() {
      this.$router.back();
    },
  },
};
</script>

<style lang="scss">
#new-negotiation {
  .mt-10-topo {
    position: relative;
    top: -18px;
    margin: 0;
    padding: 0;
  }
}
</style>
